// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const it: KnowledgePagesCopy = {
  knowledgePage: 'Pagina di conoscenza',
  knowledgePages: 'Pagine di conoscenza',
  featureOffTitle: 'Le pagine di conoscenza non sono attive in questo spazio di lavoro.',
  featureOffBody: 'Il contesto aziendale e le fonti restano in Conoscenze.',
  loadingPage: 'Caricamento della pagina…',
  loadingSuggestion: 'Caricamento del suggerimento…',
  cancel: 'Annulla',
  tryAgain: 'Riprova',
  everyoneIn: 'Tutti presso {company}',
  yourCompany: 'la tua azienda',
  revision: 'Revisione {n}',
  openRevision: 'Apri la revisione {n}',
  pageCount: 'one:pagina|other:pagine',
  topicCount: 'one:argomento|other:argomenti',
  sectionCount: 'one:sezione|other:sezioni',
  lineCount: 'one:riga|other:righe',
  documentCount: 'one:documento|other:documenti',
  changeCount: 'one:modifica|other:modifiche',
  newPageCount: 'one:nuova pagina|other:nuove pagine',
  changedPageCount: 'one:pagina modificata|other:pagine modificate',
  otherSectionCount: 'one:altra sezione|other:altre sezioni',
  characterCount: 'one:carattere|other:caratteri',
  diffStats: 'Modificate: {sections} · aggiunte: {added} · rimosse: {removed}',
  diffMatchesBase: 'Il testo proposto corrisponde alla revisione di base.',
  diffIntroduction: 'Introduzione',
  diffOtherUnchanged: '{sections} senza modifiche.',
  timeJustNow: 'poco fa',
  originImportedFrom: 'Importata da {path}',
  originImportedFromCommit: 'Importata da {path} @ {commit}',
  authorityApprovedInPoneva: 'Approvata in Poneva',
  authorityImported: 'Importata',
  authorityInRepository: '{canonicality} nel repository',
  authorityVerified: 'verificata il {date}',
  authorRepositoryImport: 'Importazione dal repository',
  authorSuggestedInChat: 'Suggerita in chat',
  authorSuggestedInChatWith: 'Suggerita in chat con {name}',
  authorSuggestedBy: 'Suggerita da {name}',
  authorSuggestedByApp: 'Suggerita da un’app collegata',
  authorSuggestedByColleague: 'Suggerita da un collega',
  authorSuggestedByYou: 'Suggerita da te',
  authorSuggestedOnBehalf: 'Suggerita da {app} per conto di {name}',
  authorSuggestedByAppOnBehalf: 'Suggerita da un’app collegata per conto di {name}',
  authorSuggestedAndApproved: 'Suggerita e approvata da {name}',
  approverApprovedBy: 'approvata da {name}',
  approverAppliedBy: 'applicata da {name}',
  kindCreatePage: 'Nuova pagina',
  kindUpdatePage: 'Aggiornamento proposto',
  kindArchivePage: 'Archiviazione',
  statusConflict: 'Conflitto · pagina modificata',
  statusPending: 'In attesa di revisione',
  statusApproved: 'Approvato',
  statusRejected: 'Scartato',
  statusWithdrawn: 'Ritirato',
  statusSuperseded: 'Sostituito',
  errRevisionConflict: 'Questa pagina è cambiata mentre la stavi rivedendo.',
  errProposalChanged:
    'Questo suggerimento è cambiato mentre lo stavi rivedendo. Rivedi l’ultima versione prima di decidere.',
  errPublishRequired:
    'Solo gli editor dell’azienda possono approvare modifiche alle conoscenze o importare pagine.',
  errProposalLimit:
    'La tua azienda ha già 200 suggerimenti in attesa di revisione. Rivedine alcuni prima di suggerirne altri.',
  errAuthorLimit:
    'Hai già 50 suggerimenti in attesa di revisione. Aspetta che su alcuni venga presa una decisione, oppure ritirane qualcuno, prima di suggerirne altri.',
  errImportProposalLimit:
    'Questa importazione aggiungerebbe più pagine modificate da rivedere di quante ne possa contenere la coda di revisione della tua azienda (200 al massimo). Decidi su alcuni suggerimenti in Da rivedere, poi applica di nuovo.',
  errImportChanged:
    'Questa importazione non è quella che hai rivisto. Aprila di nuovo e rivedila prima di applicarla.',
  errImportItemNotFound: 'Questo documento non fa più parte dell’importazione.',
  errIdempotencyConflict:
    'Questo suggerimento è già stato inviato con un contenuto diverso. Ricarica e riprova.',
  errImportHashMismatch:
    'Un file di questo snapshot non corrisponde al checksum registrato. Crea di nuovo lo snapshot e riprova.',
  errImportAlreadyApplied: 'Questa importazione è già stata applicata.',
  errImportDiscarded:
    'Questa importazione è stata scartata. Scegli di nuovo il file dello snapshot.',
  errImportDuplicateItem:
    'Questo snapshot elenca due volte lo stesso documento. Crea di nuovo lo snapshot.',
  errInvalidImport:
    'Poneva non ha potuto accettare questo snapshot. Crealo di nuovo con lo script dello snapshot e riprova.',
  errInvalidInput: 'Poneva non ha potuto accettare questi dati. Controlla i campi e riprova.',
  errImportLimit:
    'Ci sono troppe importazioni preparate ma non applicate. Applicane o scartane alcune prima di prepararne un’altra.',
  errPageTooLarge: 'Una pagina supera 256 KB. Dividila in pagine più piccole.',
  errTooManySections: 'Una pagina ha più di 2.000 titoli. Dividila in pagine più piccole.',
  errPageLimit: 'La tua azienda ha raggiunto il limite di 2.000 pagine di conoscenza.',
  errCollectionLimit: 'La tua azienda ha raggiunto il limite di 100 argomenti.',
  errProposalNotPending:
    'Su questo suggerimento è già stata presa una decisione. Lo stato mostrato è aggiornato.',
  errRequesterRemoved:
    'La persona che l’ha suggerito non fa più parte di questa azienda, quindi non può essere approvato.',
  errRevisionAlreadyCurrent: 'Quella revisione è già quella attuale.',
  errPageArchived:
    'Questa pagina è stata archiviata mentre la stavi rivedendo. Rivedi di nuovo il suggerimento prima di decidere.',
  errAlreadyArchived: 'Questa pagina è già archiviata.',
  errProposalForbidden: 'Solo la persona che l’ha suggerito può ritirarlo.',
  errUnavailable: 'Le pagine di conoscenza non sono disponibili al momento.',
  errTimeout: 'Poneva ha impiegato troppo tempo a rispondere.',
  errItemTooLarge: '{path} supera 256 KB. Dividilo in pagine più piccole.',
  errItemTooManySections: '{path} ha più di 2.000 titoli. Dividilo in pagine più piccole.',
  errItemHashMismatch:
    '{path} non corrisponde al checksum registrato. Crea di nuovo lo snapshot e riprova.',
  errNoLongerAvailable: 'Questo elemento non è più disponibile per te.',
  errTooLargeToSend: 'Questo file è troppo grande per essere inviato.',
  cardChecking: 'Controllo dello stato…',
  cardNotAvailable: 'Non disponibile',
  cardStatusUnavailable: 'Stato non disponibile',
  cardUnshowable: 'Non è stato possibile mostrare questo aggiornamento suggerito delle conoscenze.',
  cardEyebrow: 'Aggiornamento suggerito delle conoscenze',
  cardLabel: 'Aggiornamento suggerito delle conoscenze · {title}',
  cardMissing: 'Questo suggerimento non è più disponibile per te.',
  cardUnknown:
    'Non siamo riusciti a verificare a che punto è questo suggerimento. Apri la revisione per vederne lo stato.',
  cardCheckAgain: 'Controlla di nuovo',
  cardReview: 'Rivedi l’aggiornamento',
  statusLineApproved: 'Comprensione approvata',
  readyCount: 'one:pronto per la ricerca|other:pronti per la ricerca',
  preparingCount: 'one:in preparazione|other:in preparazione',
  attentionCount: 'one:richiede attenzione|other:richiedono attenzione',
  topicsExplore: 'Esplora un argomento',
  topicsAllPages: 'Tutte le pagine',
  topicsOpenPages: 'Apri Pagine',
  topicsEmpty:
    'Nessuna pagina approvata per ora. Le pagine raccolgono la conoscenza aziendale estesa, con la cronologia completa delle revisioni.',
  reviewsTitle: 'Aggiornamenti suggeriti alle pagine',
  reviewsTitleMine: 'I tuoi aggiornamenti suggeriti alle pagine',
  reviewsIntro:
    'Ogni suggerimento è una revisione candidata completa, con motivo ed evidenze. Non cambia nulla finché non approvi esattamente quella revisione.',
  reviewsIntroMine:
    'I tuoi suggerimenti restano qui finché un editor dell’azienda non li esamina. Fino ad allora le pagine restano come sono.',
  loadPagesFailed: 'Non siamo riusciti a caricare le pagine di conoscenza.',
  loadProposalsFailed: 'Non siamo riusciti a caricare gli aggiornamenti suggeriti alle pagine.',
  loadMoreFailed: 'Non siamo riusciti a caricare altre pagine.',
  otherPages: 'Altre pagine',
  loadTopicFailed: 'Non siamo riusciti a caricare questo argomento.',
  revisionShort: 'r{n}',
  updatedOn: 'Aggiornata il {date}',
  emptyTitle: 'Nessuna pagina di conoscenza per ora.',
  emptyBody:
    'Le pagine raccolgono la conoscenza approvata ed estesa della tua azienda — direzione, decisioni e modi di lavorare — conservando ogni revisione. Importale da uno snapshot del repository o inizia una pagina in chat; un editor dell’azienda approva ogni pagina prima che diventi conoscenza aziendale.',
  importFromSnapshot: 'Importa da uno snapshot del repository',
  startInChat: 'Inizia una pagina in chat',
  startInChatPrompt:
    'Aiutami a iniziare una pagina di conoscenza per la nostra azienda. Chiedimi cosa deve trattare e non inventare contenuti. Resta un suggerimento finché un editor dell’azienda non la approva.',
  loadingPages: 'Caricamento delle pagine di conoscenza…',
  filterLabel: 'Filtra le pagine per titolo',
  filterPlaceholder: 'Filtra le pagine',
  importButton: 'Importa',
  showingTopic: 'Argomento mostrato: {topic}',
  showAllTopics: 'Mostra tutti gli argomenti',
  loadingTopic: 'Caricamento dell’argomento…',
  noMatch: 'Nessuna pagina corrisponde a “{filter}”.',
  topicNoPages: 'Ancora nessuna pagina approvata in questo argomento.',
  loading: 'Caricamento…',
  loadMore: 'Carica altre pagine',
  metaApproved: 'approvata il {date}',
  metaRepositoryAuthoritative: 'il repository resta la fonte di riferimento',
  loadPageFailed: 'Non siamo riusciti a caricare questa pagina.',
  loadHistoryFailed: 'Non siamo riusciti a caricare la cronologia delle revisioni.',
  outlineLabel: 'Sezioni della pagina',
  outlineToggle: 'In questa pagina',
  loadingHistory: 'Caricamento della cronologia delle revisioni…',
  historyLabel: 'Cronologia delle revisioni',
  historyIntro:
    'Ogni revisione approvata viene conservata. Ripristinarne una precedente crea un suggerimento da rivedere; non cancella mai le revisioni successive.',
  historyCurrent: 'Attuale',
  historyViewing: 'In visualizzazione',
  historyView: 'Visualizza',
  historyViewAria: 'Visualizza la revisione {n}',
  restoreAria: 'Ripristina come suggerimento: revisione {n}',
  restoreCreating: 'Creazione del suggerimento…',
  restore: 'Ripristina come suggerimento',
  restoreUnconfirmed:
    'Non siamo riusciti a confermare che il suggerimento sia stato creato. Controlla Da rivedere prima di riprovare.',
  editTooLarge: 'Questa pagina supera 256 KB. Dividila in pagine più piccole prima di suggerirla.',
  editConflict:
    'Questa pagina è cambiata mentre la modificavi. Copia il tuo testo, apri l’ultima revisione e suggerisci di nuovo la modifica.',
  editUnconfirmed:
    'Non siamo riusciti a confermare che il tuo suggerimento sia stato inviato. Controlla Da rivedere prima di inviarlo di nuovo.',
  editHeading: 'Suggerisci una modifica',
  editIntro:
    'Stai modificando la revisione {n}. Un editor dell’azienda esamina la modifica esatta prima che diventi la revisione {next}; fino ad allora la pagina resta com’è.',
  editOutdated:
    'Mentre modificavi è stata approvata una revisione più recente. Copia il tuo testo, poi ricomincia dall’ultima revisione per non perdere nulla di ciò che ha cambiato.',
  editContentLabel: 'Contenuto della pagina (Markdown)',
  editReasonLabel: 'Perché questa modifica?',
  editReasonPlaceholder: 'Cosa è cambiato e da dove viene.',
  editSending: 'Invio…',
  editSend: 'Invia per la revisione',
  editDiscardConfirm: 'Scartare questa modifica? Nulla di ciò che hai cambiato è stato inviato.',
  editNoChanges: 'Ancora nessuna modifica.',
  editNeedsContent: 'Una pagina deve avere un contenuto.',
  exportFailed: 'Non siamo riusciti a esportare questa pagina. Riprova.',
  askPagePrompt: 'Domanda sulla pagina di conoscenza “{title}” (revisione {n}, {link}):',
  askPageSectionPrompt:
    'Domanda sulla pagina di conoscenza “{title}” § {section} (revisione {n}, {link}):',
  pageMissingTitle: 'Questa pagina non è disponibile.',
  pageMissingBody:
    'Potrebbe essere stata archiviata, oppure potresti non avere più accesso alle conoscenze di questa azienda.',
  pageArchived: 'Archiviata',
  viewingRevisionCurrent: 'Stai visualizzando la revisione {n}; quella attuale è la {current}.',
  viewingRevisionOld: 'Stai visualizzando la revisione {n}. Non è la revisione attuale.',
  openCurrent: 'Apri l’attuale',
  archivedBanner:
    'Questa pagina è archiviata. Non contribuisce più alle risposte; la sua cronologia viene conservata.',
  pageViewsLabel: 'Viste della pagina',
  tabRead: 'Leggi',
  tabHistory: 'Cronologia',
  unknownSection:
    'La sezione collegata non fa parte di questa revisione. Viene mostrata l’intera pagina.',
  askAboutPage: 'Chiedi di questa pagina',
  exporting: 'Esportazione…',
  exportMarkdown: 'Esporta in Markdown',
  loadSuggestionFailed: 'Non siamo riusciti a caricare questo suggerimento.',
  evidenceSource: 'Fonte',
  evidenceFact: 'Contesto aziendale',
  evidenceResult: 'Lavoro salvato',
  evidenceUrl: 'Pagina web',
  evidenceDecision: 'Decisione',
  evidenceReference: 'Riferimento',
  evidenceOpenPage: 'Apri la pagina di conoscenza',
  evidenceOpenSource: 'Apri la fonte',
  evidenceOpenFact: 'Apri il contesto aziendale',
  evidenceOpenResult: 'Apri il lavoro salvato',
  evidenceOpenUrl: 'Apri la pagina web',
  evidenceOpenDecision: 'Apri la decisione',
  evidenceOpenReference: 'Apri il riferimento',
  evidenceDecisionNote: 'Una decisione registrata. In Poneva non c’è nulla da aprire.',
  evidenceFactGone: 'Questo contesto aziendale non è più salvato.',
  evidencePageNoRevision: 'Questa pagina non ha una revisione approvata da aprire.',
  evidencePrivateExcerpt: 'Evidenza privata — è stato condiviso solo l’estratto qui sopra.',
  evidencePrivate: 'Evidenza privata — il suo contenuto non è stato condiviso con te.',
  evidenceHeading: 'Evidenze',
  evidenceNone: 'Non è stata allegata alcuna evidenza. Valuta il motivo qui sopra di per sé.',
  changeAdded: 'Aggiunta',
  changeRemoved: 'Rimossa',
  changeChanged: 'Modificata',
  changeUnchanged: 'Invariata',
  moreLineCount: 'one:altra riga|other:altre righe',
  moreUnchangedLineCount: 'one:altra riga invariata|other:altre righe invariate',
  unchangedLineCount: 'one:riga invariata|other:righe invariate',
  skipAdded: '{lines} — nella revisione completa',
  skipRemoved: 'Rimozione: {lines}',
  cutUnchanged: 'Non mostrate: {lines}',
  cutChanged: 'Non mostrate: {lines}; {changes}. Controllale nella revisione completa.',
  cutAddedRemoved: 'aggiunte: {added}, rimosse: {removed}',
  cutAdded: 'aggiunte: {added}',
  cutRemoved: 'rimosse: {removed}',
  lineAddedSr: 'Aggiunta:',
  lineRemovedSr: 'Rimossa:',
  noLinesAdded: 'Una nuova sezione. Il suo testo è nella revisione completa qui sotto.',
  noLinesRemoved: 'Questa sezione verrebbe rimossa dalla pagina.',
  noLinesChanged: 'Questa sezione cambia. Il suo testo è nella revisione completa qui sotto.',
  diffHeading: 'Modifiche',
  outcomeArchived: 'Archiviata.',
  outcomeArchivedBody:
    '{title} non contribuisce più alle risposte ed è uscita dall’elenco delle pagine. Le sue revisioni, questo suggerimento e la decisione restano nella cronologia della pagina.',
  openArchivedPage: 'Apri la pagina archiviata',
  outcomeApproved: 'Approvato.',
  outcomeApprovedRevision: 'La revisione {n} è ora la versione approvata di {title}.',
  outcomeApprovedPlain: 'Questo suggerimento è stato approvato.',
  outcomeRestored:
    'La pagina è tornata nell’elenco delle pagine e contribuisce di nuovo alle risposte.',
  outcomeKept:
    'Il suggerimento, la decisione e ogni revisione precedente restano nella cronologia della pagina.',
  openPage: 'Apri la pagina',
  outcomeDismissed: 'Scartato.',
  outcomeWithdrawn: 'Ritirato.',
  outcomeSuperseded: 'Sostituito.',
  outcomeSupersededBody:
    'Una revisione, un suggerimento o un’importazione dal repository più recente ha reso obsoleto questo suggerimento. Da solo non ha cambiato nulla.',
  outcomeUnchanged: 'La pagina resta com’è.',
  approveNewPage: 'Approva la nuova pagina',
  approveArchive: 'Approva l’archiviazione',
  approveRestoreRevision: 'Ripristina e approva la revisione {n}',
  approveRevision: 'Approva la revisione {n}',
  approveArchiveNote: 'Approvando, questa pagina viene archiviata per tutti presso {company}.',
  approvePublishNote: 'Approvando, questa revisione viene pubblicata per tutti presso {company}.',
  approvePublishEvidenceNote:
    'Approvando, questa revisione e gli estratti delle evidenze mostrati sopra vengono pubblicati per tutti presso {company}.',
  archivedTitle: 'Questa pagina è archiviata.',
  alreadyArchivedBody:
    'Approvare non cambierebbe nulla, quindi questo suggerimento può solo essere scartato.',
  archivedRestoreBody:
    'Approvando la ripristini: la pagina torna nell’elenco delle pagine, nella ricerca e nelle risposte con questa revisione.',
  staleRevisionAction: 'Confronta con l’ultima versione',
  staleProposalTitle: 'Questo suggerimento è cambiato mentre lo stavi rivedendo.',
  staleProposalAction: 'Rivedi l’ultima versione',
  staleArchivedTitle:
    'Questa pagina è stata archiviata mentre la stavi rivedendo. Approvare questo suggerimento la ripristinerebbe.',
  staleArchivedAction: 'Rivedi di nuovo',
  suggestionMissingTitle: 'Questo suggerimento non è disponibile.',
  suggestionMissingBody:
    'Potrebbe essere stato ritirato, oppure appartiene a un’altra persona e non è stato inviato per la revisione aziendale.',
  decideUnconfirmed:
    'Non siamo riusciti a confermare la tua decisione. Lo stato mostrato è l’ultimo ricevuto da Poneva; controllalo prima di riprovare.',
  decideFailed: 'Non siamo riusciti a salvare la tua decisione.',
  discussPrompt:
    'Aiutami a perfezionare l’aggiornamento suggerito delle conoscenze per “{title}” ({link}).',
  conflictBody:
    'Questo suggerimento è stato scritto sulla revisione {base}; quella attuale è la {current}. Approvarlo sovrascriverebbe quella modifica, quindi non può essere approvato così com’è.',
  conflictBodyPlain:
    'Questo suggerimento è stato scritto su una revisione precedente, quindi non può essere approvato così com’è.',
  openLatest: 'Apri l’ultima versione',
  reworkInChat: 'Rielabora in chat',
  factReason: 'Motivo',
  factNoReason: 'Non è stato indicato alcun motivo.',
  factAudience: 'Destinatari',
  factRevision: 'Revisione',
  revisionNew: 'Una nuova pagina, revisione 1',
  revisionArchiveAfter: 'Archiviazione dopo la revisione {n}',
  revisionWrittenAgainst: 'Scritto sulla revisione {base}; quella attuale è la {current}',
  revisionCurrentToProposed: 'Revisione attuale {base} → revisione proposta {next}',
  revisionProposed: 'Revisione proposta {next}',
  proposedPage: 'Pagina proposta',
  archivingHeading: 'Cosa comporta l’archiviazione',
  archivingBody:
    'La pagina smette di contribuire alle risposte ed esce dall’elenco delle pagine. Le sue revisioni e questa decisione vengono conservate.',
  noComparison: 'Per questo suggerimento non è disponibile un confronto per sezioni.',
  showComplete: 'Mostra la revisione completa',
  approving: 'Approvazione…',
  dismissing: 'Scarto in corso…',
  dismiss: 'Scarta',
  withdrawing: 'Ritiro in corso…',
  withdraw: 'Ritira',
  editInChat: 'Modifica in chat',
  waitingForPublisher: 'In attesa dell’esame di un editor dell’azienda.',
  snapshotTooLarge: 'Questo snapshot supera 8 MB. Crealo con meno documenti.',
  snapshotNotSnapshot:
    'Questo file non è uno snapshot delle conoscenze. Scegli il file JSON generato dallo script dello snapshot.',
  snapshotEmpty: 'Questo snapshot non contiene documenti.',
  readDocumentFailed: 'Non siamo riusciti a leggere questo documento. Riprova.',
  readingDocument: 'Lettura del documento…',
  hideText: 'Nascondi testo',
  readText: 'Leggi testo',
  textOf: 'Testo di {title}',
  gitSnapshot: 'Snapshot Git {commit}',
  repositorySnapshot: 'Snapshot del repository',
  importNewHeading: '{pages} · approvazione all’applicazione',
  importNewNote:
    'Ognuna viene pubblicata come pagina approvata per tutti presso {company}, senza ulteriore revisione. Leggile una per una prima di applicare.',
  importChangedHeading: '{pages} · invio per la revisione',
  importChangedNote:
    'Ognuna diventa un aggiornamento suggerito. La sua pagina cambia solo quando un editor dell’azienda lo approva in Da rivedere, che mostra cosa è cambiato.',
  unchangedDocumentCount: 'one:documento invariato|other:documenti invariati',
  unchangedNote:
    'Questi documenti corrispondono già alle loro pagine approvate. Non viene scritto nulla per loro.',
  stagedHeading: 'Preparata ma non applicata',
  excludedSummary: 'Fuori da questo snapshot: {documents}',
  countsLine: '{newPages} · {changedPages} da rivedere · invariati: {unchanged}',
  importAlreadyDiscarded: 'Questa importazione è già stata scartata.',
  confirmLabel: 'Conferma importazione',
  unchangedKeepCount:
    'one:documento invariato mantiene la sua pagina|other:documenti invariati mantengono le loro pagine',
  confirmBody:
    'Applicare questa importazione per tutti presso {company}? Approvazione come revisione 1: {newPages}; in attesa di revisione: {changedPages}; infine, {unchanged}. I precedenti suggerimenti di importazione per queste pagine vengono ritirati.',
  applying: 'Applicazione…',
  applyImport: 'Applica importazione',
  chooseAnother: 'Scegli un altro file',
  allCurrent: 'Tutto il contenuto di questo snapshot è già aggiornato.',
  importApplied: 'Importazione applicata.',
  appliedSummary: 'Create: {pages} · in attesa di revisione: {changes} · invariati: {unchanged}.',
  appliedIndexing:
    'Le nuove pagine diventano ricercabili in chat al termine dell’indicizzazione. La preparazione delle fonti mostra l’avanzamento.',
  openPages: 'Apri le pagine',
  reviewChanges: 'Rivedi {changes}',
  checkIndexing: 'Controlla l’avanzamento dell’indicizzazione',
  sendSnapshotFailed: 'Non siamo riusciti a inviare questo snapshot. Riprova.',
  openStagedFailed: 'Non siamo riusciti ad aprire questa importazione preparata.',
  applyUnconfirmed:
    'Non siamo riusciti a confermare se l’importazione è stata applicata. Controlla Pagine prima di riprovare.',
  applyFailed: 'Non siamo riusciti ad applicare questa importazione.',
  importHeading: 'Importa pagine dal repository',
  backToPages: 'Torna alle pagine',
  importLead:
    'Crea uno snapshot con {command}, poi scegli il file. Vedrai ogni documento e cosa cambierebbe prima che venga salvato qualcosa.',
  snapshotFileLabel: 'File dello snapshot delle conoscenze',
  readingSnapshot: 'Lettura dello snapshot…',
  openingStaged: 'Apertura dell’importazione preparata…',
  chooseSnapshot: 'Scegli il file dello snapshot',
  factOrigin: 'Origine',
  factContents: 'Contenuto',
  importOnlyListed: 'Vengono importati solo i documenti elencati qui.',
  importRepositoryAuthoritative:
    'Il repository resta la fonte di riferimento; i documenti modificati diventano suggerimenti da rivedere.',
  overviewReviewChanges: 'Rivedi le modifiche',
  overviewConnectAgents: 'Collega agenti esterni',
  overviewEyebrow: 'Una comprensione condivisa',
  overviewTitle: '{company}, nel contesto.',
  overviewLeadFallback:
    'Le conoscenze della tua azienda partono dal contesto che condividi. Costruiamo insieme una comprensione della tua attività.',
  overviewBody:
    'Il contesto aziendale e le fonti danno a Poneva un punto di partenza — non tutto ciò che c’è da sapere su {company}. Continua ad ampliare questa comprensione man mano che la tua attività evolve.',
  overviewAskPrompt: 'Cosa sai della nostra azienda e cosa sarebbe utile aggiungere?',
  overviewAsk: 'Chiedi di {company}',
  overviewAddSources: 'Aggiungi fonti',
  contextEyebrow: 'Cosa dà contesto alle risposte',
  contextTitle: 'L’azienda dietro la domanda.',
  contextBody:
    'Le fonti web descrivono l’attività pubblica. Le note aziendali aggiungono la tua terminologia, le tue priorità e il tuo modo di lavorare.',
  contextPrompt:
    'Aiutami a chiarire le priorità aziendali e le preferenze di lavoro che dovremmo ricordare.',
  contextAction: 'Costruisci la nostra comprensione',
  learnEyebrow: 'Spazio per imparare',
  learnTitle: 'Inizia da ciò che conta adesso.',
  learnBody:
    'Aggiungi fonti o chiarisci come lavora la tua azienda. Poneva può suggerire cambiamenti duraturi che potrai rivedere.',
  learnPrompt:
    'In base alle conoscenze aziendali attuali, quali informazioni importanti mancano per il lavoro che vogliamo fare?',
  learnAction: 'Discuti cosa sarebbe utile',
  canvasEmptyTitle: 'Un po’ di contesto fa molta strada.',
  canvasEmptyBody:
    'Il profilo della tua azienda è il punto di partenza. Aggiungi fonti e note revisionate per aiutare Poneva a capire il tuo lavoro.',
  pageEyebrow: 'Area di lavoro di {company}',
  pageTitle: 'Conoscenze aziendali',
  pageDescription: 'Le fonti e la comprensione alla base del lavoro di Poneva.',
  tabOverview: 'Panoramica',
  tabPages: 'Pagine',
  tabSources: 'Fonti',
  tabReview: 'Da rivedere',
  proposalApproved: 'Contesto aziendale approvato',
  proposalDismissed: 'Suggerimento scartato',
  proposalRemoval: 'Rimozione proposta',
  proposalCorrection: 'Correzione proposta',
  proposalContext: 'Contesto aziendale proposto',
  proposalCurrent: 'Comprensione attuale',
  proposalFactGone:
    'Il fatto salvato non è più disponibile. Aggiorna le conoscenze aziendali prima di rivedere questa rimozione.',
  proposalReviewFallback: 'Rivedi il contesto aziendale proposto.',
  proposalNotSaved: 'Non ancora salvato. Le fonti originali restano invariate.',
  proposalWaiting:
    'In attesa di revisione · decide un editor dell’azienda nella sua Posta in arrivo',
  proposalSaving: 'Salvataggio…',
  proposalApproveRemoval: 'Approva la rimozione',
  proposalApproveClarification: 'Approva il chiarimento',
  factLabel: 'Fatto aziendale',
  factEyebrow: 'Fatto · Tutti presso {company}',
  factSuggestCorrection: 'Suggerisci una correzione',
  factAskPrompt: 'Aiutami a capire o chiarire questo contesto aziendale salvato: “{content}”',
  factAsk: 'Chiedi informazioni',
  companyContextHeading: 'Contesto aziendale',
  companyContextPrompt:
    'Vorrei chiarire le conoscenze della nostra azienda. Aiutami a rivedere ciò che sappiamo e a proporre un aggiornamento.',
  companyContextEmpty:
    'Nessuna nota approvata per ora. Avvia una conversazione sulla tua azienda o aggiungi fonti qui sotto.',
  refineInChat: 'Perfeziona in chat',
  reviewPanelLabel: 'Modifiche alle conoscenze da rivedere',
  suggestedUpdatesHeading: 'Aggiornamenti suggeriti',
  suggestedUpdatesIntro:
    'Suggerimenti dalle tue conversazioni. Sei tu a decidere cosa entra a far parte delle conoscenze durature della tua azienda.',
  reviewEmptyTitle: 'Niente in attesa della tua revisione.',
  reviewEmptyBody:
    'Quando Poneva suggerisce una modifica alle conoscenze della tua azienda, la trovi qui. Le modifiche durature richiedono sempre la tua approvazione.',
  reviewEmptyPrompt:
    'Aiutami a rivedere le conoscenze della nostra azienda e suggerisci cosa sarebbe utile chiarire come prossimo passo.',
  inclusionPendingApproval: 'Modifica dell’inclusione nelle conoscenze inviata per l’approvazione.',
  sourcesFileIncluded: 'File incluso nella ricerca delle conoscenze per il suo pubblico attuale.',
  sourcesAddFailed: 'Impossibile aggiungere questa fonte.',
  sourcesHeading: 'Il materiale dietro le risposte.',
  sourcesIntro:
    'Poneva cerca nell’intero materiale delle fonti, non solo nella panoramica. Conserva gli originali, guarda cosa è pronto e scegli cosa contribuisce alle tue risposte.',
  addSourceHeading: 'Aggiungi materiale della tua azienda',
  addSourceIntro:
    'Le fonti caricate restano private nella tua Libreria e contribuiscono solo alle tue risposte. Scegli Condividi quando vuoi renderle disponibili ai colleghi.',
  uploadSource: 'Carica una fonte',
  addSourcePrompt:
    'Aiutami ad aggiungere una dichiarazione aziendale come fonte interna condivisa. Chiedimi cosa vorrei registrare; non inventare alcun contenuto. Le modifiche durature alla comprensione aziendale richiedono comunque la mia approvazione.',
  addThroughChat: 'Aggiungi tramite chat',
  addingSource: 'Aggiunta…',
  addToKnowledge: 'Aggiungi alle conoscenze',
  uploadFormats: 'TXT, Markdown, CSV e JSON · Fino a 5 MB per file',
  sourceExcluded: 'Esclusa dalle risposte',
  sourcePreparationFailed: 'Preparazione non riuscita',
  sourcePreparing: 'In preparazione per la ricerca',
  sourceWaiting: 'In attesa di preparazione',
  sourceReadinessUnknown: 'Stato di preparazione non disponibile',
  sourceRetryQueued: 'Preparazione in coda. Lo stato si aggiornerà al termine.',
  sourceIncludedNotice: 'Fonte inclusa. Poneva la preparerà per la ricerca.',
  sourceExcludedNotice: 'Esclusa dalle risposte. La fonte originale viene conservata.',
  sourceUpdateFailed: 'Impossibile aggiornare questa fonte.',
  sourceOriginalMaterial: 'Materiale originale della fonte',
  sourceDiscuss: 'Discuti in chat',
  sourceDiscussPrompt: 'Aiutami a capire o chiarire “{title}”.',
  sourceExclude: 'Escludi dalle risposte',
  sourceInclude: 'Includi nelle risposte',
  sourcesLoadFailed: 'Non siamo riusciti a caricare le tue fonti.',
  sourceLibraryLabel: 'Libreria delle fonti aziendali',
  sourceListCaption: 'Fonti originali · incluse ed escluse',
  sourceSearchLabel: 'Cerca nelle fonti aziendali',
  sourceSearchPlaceholder: 'Cerca nelle tue fonti…',
  sourcesFinding: 'Ricerca delle tue fonti…',
  sourcePagesLabel: 'Paginazione delle fonti',
  sourceRange: '{from}–{to} di {count}',
  sourceCount: 'one:fonte|other:fonti',
  sourcePrevious: 'Precedente',
  sourceNext: 'Avanti',
  sourceNoMatchTitle: 'Nessuna fonte corrispondente.',
  sourceNoMatchBody: 'Prova con un’altra frase o un altro nome di fonte.',
  sourceEmptyTitle: 'Dai alle tue domande un punto di partenza più solido.',
  sourceEmptyBody:
    'Aggiungi documenti aziendali, dati di prodotto o note di lavoro. Poneva può usare l’intero materiale delle fonti nelle conversazioni e nelle Skills.',
  indexCheckFailed: 'Non siamo riusciti a verificare la preparazione delle fonti.',
  indexRetryQueued:
    'Le voci di conoscenza non riuscite sono state messe in coda per la preparazione. Il materiale delle fonti è invariato.',
  indexQueueFailed: 'Non siamo riusciti a mettere in coda la preparazione. Riprova.',
  indexPreparing: 'Preparazione di nuove conoscenze per le tue conversazioni…',
  indexAttention: 'Alcune conoscenze richiedono attenzione.',
  queuing: 'Messa in coda…',
  retryPreparation: 'Riprova la preparazione',
  sourceKindStatement: 'Dichiarazione aziendale',
  sourceKindWebsite: 'Sito web',
  sourceKindDocument: 'Documento',
  factAnswers: 'one:risposta|many:risposte|other:risposte',
  factUsedThisWeek: 'Usato in {answers} questa settimana',
  factLastUsed: 'ultimo utilizzo: {when}',
  factToday: 'oggi',
  factYesterday: 'ieri',
  factImpact: 'Questa modifica riguarda un fatto usato in {answers} questa settimana.',
  factCorrectionAbout: 'Su questo fatto aziendale: “{content}” ({link})',
  factCorrectionOutdated: 'Non è più aggiornato:',
  sourceCanvasRecorded: 'Fonte registrata',
  sourceCanvasNotIncluded:
    'Non incluso nelle conoscenze aziendali. L’originale viene conservato come riferimento e può ancora essere usato in una conversazione specifica.',
  sourceCanvasOpenOriginal: 'Apri la fonte originale',
  sourceCanvasUnavailable: 'Il contenuto della fonte non è disponibile.',
  sourceCanvasDiscussPrompt: 'Aiutami a capire o chiarire “{title}”.',
  sourceCanvasDiscuss: 'Discuti questa fonte',
  sourceCanvasCorrectionNote:
    'Una correzione diventa contesto aziendale proposto. La fonte registrata resta invariata.',
  contextCanvasEyebrow: 'Contesto aziendale disponibile',
  contextCanvasTitle: 'Le conoscenze dietro questa conversazione.',
  contextCanvasBody:
    'La comprensione approvata e le fonti aggiunte dalla tua azienda. Disponibili in chat e in Skills.',
  contextCanvasOpen: 'Apri Conoscenze',
};

export default it;
